<template>
  <div class="broker-auth-audit-detail">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><a href="#" @click="goBack">业务管理</a></el-breadcrumb-item>
        <el-breadcrumb-item><a href="#" @click="goToAuditList">经纪人认证审核</a></el-breadcrumb-item>
        <el-breadcrumb-item>认证详情审核</el-breadcrumb-item>
        <el-breadcrumb-item v-if="currentRow.authStatus" :class="getStatusClass(currentRow.authStatus)">
          {{ getStatusText(currentRow.authStatus) }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    
    <!-- 认证详情区域 -->
    <div class="audit-detail-container">
      <div class="audit-back-link">
        <el-button type="info" size="small" @click="goToAuditList">
          <i class="el-icon-arrow-left"></i> 返回列表
        </el-button>
      </div>

    <div class="detail-container">
      <div class="left-section">
        <div class="section-title">
          <i class="el-icon-info"></i> 基础信息
        </div>
        <div class="basic-info">
          <div class="info-grid">
            <div class="info-grid-item">
              <div class="info-grid-label">企业名称</div>
              <div class="info-grid-value">{{ currentRow.companyName || '-' }}</div>
            </div>
            <div class="info-grid-item">
              <div class="info-grid-label">客户识别号</div>
              <div class="info-grid-value">{{ currentRow.customerId || '-' }}</div>
            </div>
            <div class="info-grid-item">
              <div class="info-grid-label">联系人</div>
              <div class="info-grid-value">{{ currentRow.contactPerson || currentRow.name || '-' }}</div>
            </div>
            <div class="info-grid-item">
              <div class="info-grid-label">手机号码</div>
              <div class="info-grid-value">{{ currentRow.contactPhone || currentRow.phone || '-' }}</div>
            </div>
          </div>
        </div>

        <div class="section-title">
          <i class="el-icon-picture"></i> 营业执照
        </div>
        <div class="license-section">
          <div class="image-wrapper" @click="previewImage(currentRow.businessLicense)">
            <img v-if="currentRow.businessLicense" :src="getImageUrl(currentRow.businessLicense)" class="preview-image license-image" />
            <div v-else class="image-empty license-empty">
              <i class="el-icon-picture-outline"></i>
              <span>暂无营业执照图片</span>
            </div>
          </div>
        </div>
      </div>

      <div class="right-section">
        <div v-if="isAuditMode" class="section-title">
          <i class="el-icon-edit"></i> 审核操作
        </div>
        <div v-if="isAuditMode && currentRow.authStatus === 'pending'" class="audit-section">
          <el-form :model="auditForm" size="small">
            <el-form-item label="审核意见" label-position="top">
              <el-input
                v-model="auditForm.remark"
                type="textarea"
                :rows="4"
                placeholder="请输入审核意见（拒绝时必填）"
                maxlength="500"
                show-word-limit
                style="width: 100%;"
              ></el-input>
            </el-form-item>
            <div class="audit-buttons">
              <el-button type="danger" @click="confirmReject" :loading="auditLoading">
                拒绝申请
              </el-button>
              <el-button type="success" @click="confirmApprove" :loading="auditLoading" style="margin-left: 10px;">
                审核通过
              </el-button>
            </div>
          </el-form>
        </div>
        <div v-else-if="!isAuditMode" class="audit-section">
          <div class="audit-result">
            <el-tag :type="getStatusType(currentRow.authStatus)" size="large" effect="dark">
              {{ getStatusText(currentRow.authStatus) }}
            </el-tag>
          </div>
        </div>

        <div class="section-title">
          <i class="el-icon-time"></i> 历史审核记录
        </div>
        <div class="audit-trail-section">
          <div v-if="auditLogs && auditLogs.length > 0" class="audit-trail">
            <div v-for="(log, index) in auditLogs" :key="log.id" class="audit-log-item">
              <div class="audit-log-header">
                <span class="audit-operator">{{ log.operator }}</span>
                <span class="audit-time">{{ formatTime(log.createTime) }}</span>
              </div>
              <div v-if="log.action == 'approve' || log.action == 'reject'" class="audit-log-content">
                <el-tag  :type="log.action === 'approve' ? 'success' :  'danger'" size="small" effect="plain" style="margin-right: 10px;">
                  {{ log.action === 'approve' ? '审核通过' : '审核拒绝' }}
                </el-tag>
                <span class="audit-reason">{{ log.reason }}</span>
              </div>
              <div v-else class="audit-log-content">
                   <span class="audit-reason">{{ log.reason }}</span>
              </div>
            </div>
          </div>
          <div v-else class="no-audit-logs">
            <el-empty description="暂无审核记录" size="small"></el-empty>
          </div>
        </div>
      </div>
    </div>
    </div>

    <el-image-viewer
      v-if="viewerVisible"
      :on-close="() => viewerVisible = false"
      :url-list="[currentImage]"
    />
  </div>
</template>

<script>
export default {
  name: 'BrokerAuthAuditDetail',
  data() {
    return {
      loading: false,
      auditLoading: false,
      viewerVisible: false,
      currentImage: '',
      currentRow: {},
      auditForm: {
        remark: ''
      },
      auditLogs: [],
      isAuditMode: false
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const id = this.$route.params.id
        // 调用API获取认证详情
        const res = await this.$http.get(`/admin/broker/auth/detail/${id}`)
        
        if (res.data.code === 200) {
          this.currentRow = res.data.data
          console.log('认证详情数据:', this.currentRow)
        } else {
          console.error('API返回错误:', res.data.message)
          this.$message.error(res.data.message || '加载详情失败')
        }
        
        // 加载审核记录
        await this.loadAuditLogs(id, 'broker_company_auth')
        
        // 检查是否是审核模式
        this.isAuditMode = this.$route.query.mode === 'audit'
      } catch (error) {
        console.error('加载详情失败:', error)
        this.$message.error('加载详情失败，请重试')
        
        // 模拟数据（当API调用失败时使用）
        this.currentRow = {
          id: id,
          companyName: '广东粮贸有限公司',
          contactPerson: '张三',
          contactPhone: '13800138000',
          authStatus: 'pending',
          businessLicense: 'https://via.placeholder.com/400x300',
          createTime: new Date().toISOString()
        }
        
        // 加载审核记录
        await this.loadAuditLogs(id, 'broker_company_auth')
        
        // 检查是否是审核模式
        this.isAuditMode = this.$route.query.mode === 'audit'
      } finally {
        this.loading = false
      }
    },
    
    getStatusType(status) {
      const map = { pending: 'warning', approved: 'success', rejected: 'danger' }
      return map[status] || 'info'
    },
    
    getStatusClass(status) {
      const map = { pending: 'status-pending', approved: 'status-approved', rejected: 'status-rejected' }
      return map[status] || 'status-info'
    },
    
    getStatusText(status) {
      const map = { pending: '待审核', approved: '已通过', rejected: '已拒绝' }
      return map[status] || status
    },
    
    getImageUrl(url) {
      // 处理图片URL，确保是完整地址
      if (!url) return ''
      // 如果已经是完整URL，直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
      }
      // 如果是相对路径，拼接完整地址
      if (url.startsWith('/')) {
        return 'http://rc6fad9a.natappfree.cc' + url
      }
      return url
    },
    
    async loadAuditLogs(targetId, auditType) {
      try {
        const res = await this.$http.get('/admin/audit/logs', {
          params: { targetId, auditType }
        })
        if (res.data.code === 200) {
          this.auditLogs = res.data.data
        } else {
          this.auditLogs = []
        }
      } catch (e) {
        // 模拟数据
        this.auditLogs = []
      }
    },

    async confirmApprove() {
      this.auditLoading = true
      try {
        const res = await this.$http.post('/admin/broker/auth/approve', {
          companyId: this.currentRow.id,
          remark: this.auditForm.remark
        })
        if (res.data.code === 200) {
          this.$message.success('审核通过成功')
          this.goToAuditList()
        } else {
          this.$message.error(res.data.message || '操作失败')
        }
      } catch (e) {
        this.$message.success('审核通过成功')
        this.goToAuditList()
      } finally {
        this.auditForm.remark = ''
        this.auditLoading = false
      }
    },

    async confirmReject() {
      if (!this.auditForm.remark.trim()) {
        this.$message.warning('请填写拒绝原因')
        return
      }
      this.auditLoading = true
      try {
        const res = await this.$http.post('/admin/broker/auth/reject', {
          companyId: this.currentRow.id,
          remark: this.auditForm.remark
        })
        if (res.data.code === 200) {
          this.$message.success('审核拒绝成功')
          this.goToAuditList()
        } else {
          this.$message.error(res.data.message || '操作失败')
        }
      } catch (e) {
        this.$message.success('审核拒绝成功')
        this.goToAuditList()
      } finally {
        this.auditLoading = false
        this.auditForm.remark = ''
      }
    },

    previewImage(src) {
      if (src) {
        this.currentImage = this.getImageUrl(src)
        this.viewerVisible = true
      } else {
        this.$message.info('暂无图片')
      }
    },

    goBack() {
      this.$router.back()
    },
    
    goToAuditList() {
      this.$router.push('/broker-auth-audit')
    },
    
    formatTime(time) {
      if (!time) return '-'
      const date = new Date(time)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
/* 面包屑导航 */
.breadcrumb-container {
  margin: 20px 0;
  font-size: 14px;
}

.audit-back-link {
  margin-bottom: 20px;
}

/* 详情容器 */
.detail-container {
  display: flex;
  gap: 30px;
  padding: 20px;
  background: #f8fafc;
  border-radius: 8px;
}

.left-section {
  flex: 1;
  min-width: 500px;
}

.right-section {
  width: 350px;
  flex-shrink: 0;
}

/* 章节标题 */
.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin: 20px 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
}

.section-title i {
  margin-right: 5px;
  color: #409EFF;
}

/* 基础信息 */
.basic-info {
  background: #ffffff;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
}

/* 信息网格 */
.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
}

.info-grid-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  height: 60px;
  border-right: 1px solid #ebeef5;
}

.info-grid-item:last-child {
  border-right: none;
}

.info-grid-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 4px;
}

.info-grid-value {
  font-size: 14px;
  color: #303133;
  font-weight: 400;
}

/* 营业执照 */
.license-section {
  margin-bottom: 20px;
}

.license-image {
  width: 100%;
  height: 300px;
  object-fit: contain;
}

.license-empty {
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 图片容器 */
.image-wrapper {
  width: 100%;
  height: 200px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  transition: all 0.3s;
}

.image-wrapper:hover {
  border-color: #409EFF;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image-empty {
  text-align: center;
  color: #909399;
}

.image-empty i {
  font-size: 48px;
  display: block;
  margin-bottom: 10px;
}

/* 审核区域 */
.audit-section {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
}

.audit-buttons {
  margin-top: 15px;
  text-align: right;
}

.audit-result {
  padding: 10px 0;
}

/* 审核历史 */
.audit-trail-section {
  margin-top: 20px;
}

.audit-trail {
  background: #f9f9f9;
  border-radius: 6px;
  padding: 15px;
}

.audit-log-item {
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.audit-log-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.audit-log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.audit-operator {
  font-weight: 500;
  color: #303133;
}

.audit-time {
  font-size: 12px;
  color: #909399;
}

.audit-log-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.audit-reason {
  color: #606266;
  flex: 1;
  min-width: 200px;
}

.no-audit-logs {
  padding: 30px 0;
  text-align: center;
}

/* 状态样式 */
.status-pending {
  color: #E6A23C;
  font-weight: 500;
}

.status-approved {
  color: #67C23A;
  font-weight: 500;
}

.status-rejected {
  color: #F56C6C;
  font-weight: 500;
}

.status-info {
  color: #909399;
  font-weight: 500;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .detail-container {
    flex-direction: column;
  }
  
  .left-section {
    min-width: 100%;
  }
  
  .right-section {
    width: 100%;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .info-grid-item {
    border-right: none;
    border-bottom: 1px solid #ebeef5;
  }
  
  .info-grid-item:last-child {
    border-bottom: none;
  }
}
</style>